<template>
  <div>
    <el-descriptions title="基本信息" :style="isHandle ? style1 : null">
      <el-descriptions-item :label="info.releaseTenantIsPersonal ? '询价人' : '询价单位'">
        {{ info.inquirePriceParty || '--' }}
      </el-descriptions-item>
      <el-descriptions-item label="业务类型">{{ defaultFormat(info.businessTypeDesc) }}</el-descriptions-item>
      <el-descriptions-item label="交付方式">{{ defaultFormat(info.deliveryMethodDesc) }}</el-descriptions-item>
      <el-descriptions-item label="期望交期">{{ formatDate(info.expectedDeliveryDate) }}</el-descriptions-item>
      <el-descriptions-item label="创建人">{{ defaultFormat(info.createUserName) }}</el-descriptions-item>
      <el-descriptions-item label="创建人电话">{{ defaultFormat(info.createUserPhone) }}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions :style="isHandle ? style2 : null">
      <el-descriptions-item label="交付地址">{{ $route.name === 'RECOMMEND_BUSINESS_OPPORTUNITIES' ?
        defaultFormat(`${info.deliveryProvinceName || ''}${info.deliveryCityName ||
          ''}`) : defaultFormat(`${info.deliveryProvinceName || ''}${info.deliveryCityName ||
            ''}${info.deliveryAreaName || ''}${info.deliveryDetailAddress || ''}`) }}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions :style="isHandle ? style2 : null">
      <el-descriptions-item label="询单备注">{{ defaultFormat(info.inquirePriceRemark) }}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions :style="isHandle ? style3 : null" :contentStyle="{flexWrap: 'wrap'}">
      <el-descriptions-item label="附件">
        <div v-for="img in (info.inquirePriceAnnexList || [])" :key="img.url" class="fileContainer">
          <el-link style="margin-right: 4px;" type="primary" :href="img.url" :underline="false" target="blank"><i class="el-icon-document"
              style="color:#FF5959;margin-right:4px;"></i> {{ img.annexName }}</el-link>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions class="device-table" :colon="false" :style="isHandle ? style4 : null" :column="1" :labelStyle="{ margin: 0 }">
      <span slot="title">
        需求清单
        <el-button type="primary" size="mini" @click="handleExport" :loading="loading">{{ loading ? '导出中' : '导出'
          }}</el-button>
      </span>
      <el-descriptions-item>
        <TableWithPagination
          tableBorder="default"
          :columnList="columnList"
          :tableData="info.sparePartList">
        </TableWithPagination>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions :style="isHandle ? style4 : null">
      <span slot="title">收货信息</span>
      <el-descriptions-item label="收货人">{{ defaultFormat(info.deliveryUserName) }}</el-descriptions-item>
      <el-descriptions-item label="收货电话">{{ defaultFormat(info.deliveryPhone) }}</el-descriptions-item>
      <el-descriptions-item label="邮编">{{ defaultFormat(info.deliveryPostcode) }}</el-descriptions-item>
      <el-descriptions-item label="收货地址">{{ defaultFormat(`${info.deliveryProvinceName ||
        ''}${info.deliveryCityName ||
        ''}${info.deliveryAreaName || ''}${info.deliveryDetailAddress || ''}`) }}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import * as Moment from 'dayjs';
import { exportSparePart } from '@/api/businessOpportunity.js';
import TableWithPagination from '@/components/common/TableWithPagination';

export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    isHandle: {
      type: Boolean,
      default: false,
    },
    isEncryptable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TableWithPagination,
  },
  data () {
    return {
      columnList: [
        {
          tooltip: true,
          label: '备件图片',
          prop: 'imageList',
          minWidth: '100px',
          render: (h, {row}) => {
            if (row.imageList && !!row.imageList.length) {
              let previewLists = row.imageList.map(item => item.url) || [];
              return row.imageList.map((img, index) => <el-image preview-src-list={previewLists} referrer-policy='unsafe-url' z-Index={index} style={'width:40px;height:40px;vertical-align: middle;margin-right:10px'} src={img.url} ></el-image>);
            } else {
              return '--';
            }
          },
        },
        {
          tooltip: true,
          label: '备件编码',
          minWidth: '100px',
          width: '',
          prop: 'code',
        },
        {
          tooltip: true,
          label: '备件名称',
          minWidth: '120px',
          width: '',
          prop: 'name',
        },
        {
          tooltip: true,
          label: '备件型号',
          minWidth: '100px',
          width: '',
          prop: 'model',
        },
        {
          tooltip: true,
          label: '备件规格',
          minWidth: '100px',
          width: '',
          prop: 'spec',
        },
        {
          tooltip: true,
          label: '数量',
          minWidth: '80px',
          width: '',
          prop: 'quantity',
        },
        {
          tooltip: true,
          label: '单位',
          minWidth: '80px',
          width: '',
          prop: 'unitName',
        },
        {
          tooltip: true,
          label: '关联设备',
          minWidth: '150px',
          width: '',
          prop: 'device',
        },
        {
          tooltip: true,
          label: '备注',
          minWidth: '150px',
          width: '',
          prop: 'remark',
        },
      ],
      style1: {
        'margin-top': '8px',
        'padding': '18px 18px 0',
        'border-bottom-left-radius': 0,
        'border-bottom-right-radius': 0,
      },
      style2: {
        'padding': '0 18px 0',
        'border-radius': 0,
      },
      style3: {
        'padding': '0 18px 0',
        'border-top-left-radius': 0,
        'border-top-right-radius': 0,
      },
      style4: {
        'margin-top': '8px',
        'padding': '18px 18px 0',
        'border-radius': '6px',
      },
      loading: false,
    };
  },
  methods: {
    formatDate (text, fmat = 'YYYY-MM-DD') {
      return text ? Moment(text).format(fmat) : '';
    },
    defaultFormat (v) {
      return v || v === 0 ? v : '--';
    },
    download ({ data, type, fileTitle }) {
      let blob = new Blob([data], { type });
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileTitle;
      document.querySelectorAll('body')[0].appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    handleExport () {
      try {
        this.loading = true;
        exportSparePart({ inquirePriceId: this.info.id }).then(({ data }) => {
          this.download({
            data: data,
            fileTitle: `需求清单_${Moment(Date.now()).format('YYYYMMDDHHmmss')}`,
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
/deep/.el-descriptions {
  background-color: #fff;
  border-radius: 6px;
  ;

  .el-descriptions__header {
    margin-bottom: 10px;

    .el-descriptions__title {
      font-size: 14px;
    }
  }

  &.device-table {
    .el-descriptions__header {
      margin-bottom: 0px;
    }

    .el-descriptions-item__content {
      overflow: auto;
    }
  }
}
</style>
